import { v4 } from "uuid";

export const newUuid = () => {
  return v4();
};
